// extracted by mini-css-extract-plugin
export default {"dashboard":"TeacherDashboard_dashboard__GBGQ-","subPage":"TeacherDashboard_subPage__S4OTg"};